export default __webpack_public_path__ + "static/media/alphabet-yellow-n.31761125.png";